import React, { HTMLAttributes } from "react";
import { makeStyles, createStyles, Theme, useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import PageSection from "components/layout/PageSection";
import clsx from "clsx";
import titleImage from "assets/images/homePage/nextGenSection/title_nextgen.png";

import background from "assets/images/homePage/nextGenSection/bg_nextgen.jpg";
import xboxMobileBackground from "assets/images/homePage/nextGenSection/bg_nextgen_mob_xbox.jpg";
import ps5MobileBackground from "assets/images/homePage/nextGenSection/bg_nextgen_mob_ps.jpg";

import Spacer from "components/Spacer";
import Rotate from "components/rotate/Rotate";
import NextGenUpgradeTextBox from "./NextGenUpgradeTextBox";
import XboxSeriesXTextBox from "./textBoxes/XboxSeriesXTextBox";
import Playstation5TextBox from "./textBoxes/Playstation5TextBox";

const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        root: {},
        background: {
            backgroundImage: `url(${background})`,
            backgroundPosition: "center",
            backgroundSize: "cover",
        },
        xboxMobileBackground: {
            backgroundImage: `url(${xboxMobileBackground})`,
            backgroundPosition: "center",
            backgroundSize: "cover",
        },
        ps5MobileBackground: {
            backgroundImage: `url(${ps5MobileBackground})`,
            backgroundPosition: "center",
            backgroundSize: "cover",
        },
        mobileNextGenTextBox: {
            maxWidth: 550,
            flex: "1",
            width: "100%",
        },
        titleContainer: {
            paddingTop: theme.spacing(2),
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
        },
    });
});

interface IProps extends HTMLAttributes<HTMLDivElement> {}

export default function NextGenSection(props: IProps) {
    const classes = useStyles();
    const { className, id, ...rest } = props;

    const theme = useTheme();
    const mdScreen = useMediaQuery(theme.breakpoints.down("md"));

    const itemTypography = "h6";

    const title = (
        <div className={classes.titleContainer} id={id}>
            <img src={titleImage} style={{ maxWidth: 575, width: "100%" }} alt="" />
        </div>
    );

    return (
        <div className={clsx(className, classes.root)} {...rest}>
            {mdScreen ? (
                <>
                    <PageSection
                        classes={{ skewedSectionRoot: classes.xboxMobileBackground }}
                        skewed
                        topSeparatorVariant="secondary"
                    >
                        <div style={{ flex: "1" }}>
                            {title}

                            <Spacer size={4} />

                            <Rotate
                                amount={-2}
                                style={{
                                    flex: "1",
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                }}
                            >
                                <XboxSeriesXTextBox
                                    className={classes.mobileNextGenTextBox}
                                    typographyVariant={itemTypography}
                                />
                            </Rotate>
                        </div>
                    </PageSection>
                    <PageSection
                        classes={{ skewedSectionRoot: classes.ps5MobileBackground }}
                        skewed
                    >
                        <Rotate
                            amount={1}
                            style={{
                                flex: "1",
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                            }}
                        >
                            <Playstation5TextBox
                                className={classes.mobileNextGenTextBox}
                                typographyVariant={itemTypography}
                            />
                        </Rotate>
                    </PageSection>
                </>
            ) : (
                <PageSection
                    classes={{ skewedSectionRoot: classes.background }}
                    skewed
                    topSeparatorVariant="secondary"
                >
                    <div style={{ flex: "1" }}>
                        {title}

                        <Spacer size={4} />

                        <div style={{ display: "flex" }}>
                            <Rotate amount={-2} style={{ flex: "1" }}>
                                <XboxSeriesXTextBox typographyVariant={itemTypography} />
                            </Rotate>

                            <Spacer size={8} />

                            <Rotate amount={1} style={{ flex: "1" }}>
                                <Playstation5TextBox typographyVariant={itemTypography} />
                            </Rotate>
                        </div>

                        {mdScreen ? null : (
                            <>
                                <Spacer size={3} />
                                <div style={{ display: "flex", justifyContent: "center" }}>
                                    <NextGenUpgradeTextBox style={{ maxWidth: 615 }} />
                                </div>
                            </>
                        )}
                    </div>
                </PageSection>
            )}
            {mdScreen ? <NextGenUpgradeTextBox isMobile /> : null}
        </div>
    );
}
